<template>
  <a type="button" class="btn btn_action btn_delete" @click="click" :disabled="disabled" title="Smazat">Smazat</a>
</template>

<script>
export default {
  name: 'app-button-delete',
  props: {
    disabled: Boolean
  },
  methods: {
    click(e) {
      this.$emit('click', e)
    }
  }
}
</script>
